import Enumerable from "linq";
import { DateDuration } from "../../../../domain/system/DateDuration";
import { StandardOption } from "../../../system/selectors/mixins/StandardOption";

export class DateDurationOptionsSource {
  public static getPastDurationOptions(): StandardOption<DateDuration>[] {
    const todayDuration = DateDuration.today();
    return [
      new StandardOption<DateDuration>("本日", todayDuration),
      new StandardOption<DateDuration>("7日間", DateDuration.fromDays(todayDuration.from, -6)),
      new StandardOption<DateDuration>("14日間", DateDuration.fromDays(todayDuration.from, -13)),
      new StandardOption<DateDuration>("1ヶ月間", DateDuration.fromMonths(todayDuration.from, -1)),
      new StandardOption<DateDuration>("3ヶ月間", DateDuration.fromMonths(todayDuration.from, -3)),
      new StandardOption<DateDuration>("半年間", DateDuration.fromMonths(todayDuration.from, -6)),
      new StandardOption<DateDuration>("1年間", DateDuration.fromMonths(todayDuration.from, -12)),
      new StandardOption<DateDuration>("2年間", DateDuration.fromMonths(todayDuration.from, -24)),
      new StandardOption<DateDuration>("3年間", DateDuration.fromMonths(todayDuration.from, -36)),
      new StandardOption<DateDuration>("すべて", new DateDuration(null, null))
    ];
  }

  public static getFutureDurationOptions(): StandardOption<DateDuration>[] {
    const todayDuration = DateDuration.today();
    return [
      new StandardOption<DateDuration>("本日", todayDuration),
      new StandardOption<DateDuration>("3日以内", DateDuration.fromDays(todayDuration.from, 3)),
      new StandardOption<DateDuration>("7日以内", DateDuration.fromDays(todayDuration.from, 7)),
      new StandardOption<DateDuration>("14日以内", DateDuration.fromDays(todayDuration.from, 14)),
      new StandardOption<DateDuration>("すべて", new DateDuration(null, null))
    ];
  }

  public static getPastDurationByName(label: string): DateDuration {
    if (!label) { return null; }
    return this.getDurationByName(label, this.getPastDurationOptions());
  }

  public static getFutureDurationByName(label: string): DateDuration {
    if (!label) { return null; }
    return this.getDurationByName(label, this.getFutureDurationOptions());
  }

  private static getDurationByName(label: string, options: StandardOption<DateDuration>[]): DateDuration {
    if (!label) { return null; }
    return Enumerable.from(options)
      .where(o => o.label === label)
      .select(o => o.value)
      .firstOrDefault();
  }
}
